/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Modal, ModalHeader, ModalBody, Form, Col, FormGroup, FormFeedback, Label, Input, Button } from 'reactstrap'

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { AppContext } from '../AppContext'

class UserInfo extends React.Component
{
  emailAddressIsNotUsedBefore = true;
  
  async checkEmailAddress(emailAddress)
  {
    var bodyData = {};
    bodyData.emailAddress = emailAddress;
    let result = await this.context.dbTwig.callRestAPI('icam', 'validateNewEmailAddress', bodyData);
    switch (result.status)
    {
      case 'success':
        this.setState({modalButtonDisabled: false});
        break;

      case 'apiError':
        if (this.context.dbTwig.EmailExists === result.errorCode)
        {
          this.setState(
          {
            emailAddressValid: false,
            emailAddressFB: 'This email has already been registered in the system.'
          });
          break;
        }

        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new email address.');
        break;

      default:
        this.context.dbTwig.apiErrorHandler(result, 'Unable to validate new email address.');
        break;
    }
  }
  
  componentDidMount()
  {
    this.setState(
    {
      firstName: this.context.userSession.sessionInfo.firstName,
      middleName: (null === this.context.userSession.sessionInfo.middleName ? '' : this.context.userSession.sessionInfo.middleName),
      lastName: this.context.userSession.sessionInfo.lastName,
      emailAddress: this.context.userSession.sessionInfo.emailAddress
    });
  }

  constructor(props)
  {
    super();

    this.state =
    {
      firstName: '',
      firstNameValid: true,
      middleName: '', 
      lastName: '',
      lastNameValid: true,
      updateButtonDisabled: false,
      newEmailAddress: '',
      emailAddressValid: undefined,
      emailAddressFB: null,
      emailAddress: '',
      modalIsOpen: false,
      modalButtonDisabled: true,
      changeEmailStep: 1,
      validationCode: ''
    }

    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.enterNewEmail = this.enterNewEmail.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.setEmailAddress = this.setEmailAddress.bind(this);
    this.sendChangeEmailCode = this.sendChangeEmailCode.bind(this);
    this.setValidationCode = this.setValidationCode.bind(this);
    this.validateChangeEmailCode = this.validateChangeEmailCode.bind(this);
    this.generateApiToken = this.generateApiToken.bind(this);
  }

  debouncedCheckEmailAddress = window.debounce(this.checkEmailAddress, 500);

  enterNewEmail()
  {
    this.setState({modalIsOpen: true, modalButtonDisabled: true, changeEmailStep: 1});
  }

  async generateApiToken()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createApiClientToken');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating an API token');
    let jsx = (
      <div>
        An API Token has been generated.  <b>It will not be displayed again.</b>
        <br /><br />
        <CopyToClipboard text={result.jsonData.apiClientToken} 
            onCopy={() => this.context.postNotification('info', 'API token copied to paste buffer.')} >
          <span title='Click to copy...'>{result.jsonData.apiClientToken.substring(0,10) + '...' + result.jsonData.apiClientToken.substring(55,64)}</span>
        </CopyToClipboard>
        <br /><br />
        Click on the API Token to copy it to your paste buffer.  Use the API Token to register your application with the AsterionDB API.
      </div>);

    this.context.openAppModal('API Token Generated.', jsx);
  }

  render()
  {
    if (!this.props.activeTab) return false;

    let changeEmailElement = 
    ( 1 === this.state.changeEmailStep ? 
      <ModalBody>
        <FormGroup row>
          <Label sm='4' for="emailAddress">New Email Address: </Label>
          <Col sm={6}>
            <Input type="text" id="emailAddress" placeholder="Enter your email address"
              value={this.state.newEmailAddress} onChange={this.setEmailAddress} autoFocus={true}
              invalid={(undefined === this.state.emailAddressValid ? undefined : !this.state.emailAddressValid)} 
              valid={(undefined === this.state.emailAddressValid ? undefined : this.state.emailAddressValid)} 
            />
            <FormFeedback valid={false}>{this.state.emailAddressFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={{ size: 4, offset: 4 }}><Button disabled={this.state.modalButtonDisabled} onClick={this.sendChangeEmailCode} color="primary">Accept</Button></Col>
        </FormGroup>
      </ModalBody>
      :
      <ModalBody>
        <FormGroup row>
          <p>We have sent a validation code to your new email address <b>{this.state.newEmailAddress}</b></p>
          <p>Enter the validation code into the field below and press 'Accept.'</p>
          <Label for="validationCode" sm="3">Validation Code</Label>
          <Col sm={3}>
            <Input type="text" id="validationCode" placeholder="Enter the validation code..."
              value={this.state.validationCode} onChange={this.setValidationCode} autoFocus={true}
            />
          </Col>
          <Col><Button disabled={this.state.modalButtonDisabled} onClick={this.validateChangeEmailCode} color="primary">Accept</Button></Col>
        </FormGroup>
      </ModalBody>
    );

    return(
      <div>
        <Form onSubmit={(e) => this.updateUserInfo(e)}>
          <FormGroup row>
            <Label for="firstName" sm="1">First Name</Label>
            <Col sm="3">
              <Input type="text" id="firstName" placeholder="(Enter your first name...)" value={this.state.firstName} 
                onChange={this.requiredField.bind(this, 'firstName')} 
                invalid={(undefined === this.state.firstNameValid ? undefined : !this.state.firstNameValid)} 
                valid={(undefined === this.state.firstNameValid ? undefined : this.state.firstNameValid)} autoFocus
              />
              <FormFeedback valid={false}>Please specify your first name.</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="middleName" sm="1">Middle Name/Initial</Label>
            <Col sm="3">
              <Input type="text" id="middleName" placeholder="(Enter your middle name/initial...)" 
                value={this.state.middleName} onChange={(event) => this.setState({middleName: event.target.value})}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="lastName" sm="1">Last Name</Label>
            <Col sm="3">
              <Input type="text" id="lastName" placeholder="(Enter your last name...)" value={this.state.lastName} 
                onChange={this.requiredField.bind(this, 'lastName')}
                invalid={(undefined === this.state.lastNameValid ? undefined : !this.state.lastNameValid)} 
                valid={(undefined === this.state.lastNameValid ? undefined : this.state.lastNameValid)} 
              />
              <FormFeedback valid={false}>Please specify your last name.</FormFeedback>
            </Col>
          </FormGroup>
        { 'Y' === this.context.websiteProfile.smtpEnabled &&
          <FormGroup row>
            <Label for="email" sm="1">Email</Label>
            <Col sm="3">              
              <Input type="text" id="email" value={null === this.state.emailAddress ? '' : this.state.emailAddress} disabled={true} />
            </Col>
            <Col sm='2'>
              <Button title="Change Email" id="changeEmail" onClick={this.enterNewEmail} color="secondary">Change Email</Button>
            </Col>
          </FormGroup>
        }
          <FormGroup row>
            <Col sm={{ size: 2, offset: 1 }}>
              <Button title="Press this button to generate an API Token" id="generateApiToken" onClick={this.generateApiToken} color="secondary">API Token</Button>
            </Col>
            <Col sm="2">
              <Button id="updateUserInfoButton" type="submit" color="primary">Update</Button>
            </Col>
          </FormGroup>
        </Form>
        <Modal isOpen={this.state.modalIsOpen} toggle={this.toggleModal} autoFocus={false}>
          <ModalHeader toggle={(e) => {this.toggleModal(e)}}>Change Email Address</ModalHeader>
          {changeEmailElement}
        </Modal>
      </div>
    );
  }

  requiredField(field, event)
  {
    let valid = ("" === event.target.value ? false : true);
    this.setState({[event.target.id]: event.target.value, [event.target.id + 'Valid']: valid});
  }

  async sendChangeEmailCode()
  {
    var bodyData = {};
    bodyData.newEmailAddress = this.state.newEmailAddress;
    this.setState({modalButtonDisabled: true});
    let result = await this.context.dbTwig.callRestAPI('icam', 'sendChangeEmailCode', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error sending new email confirmation code.');
    this.context.postNotification('info', 'Change-Email code sent to the new email address.');
    this.setState({changeEmailStep: 2, modalButtonDisabled: true, validationCode: undefined});
  }

  setEmailAddress(event)
  {
    let valid = false;
    let value = event.target.value.trim();

    let emailAddressFB = null;
    let atSign = value.indexOf('@');
    let dot = value.lastIndexOf('.');
    if ('' === value)
    {
      valid = false;
      emailAddressFB = 'You must provide your email address.';
    }

    if ('' !== value && -1 !==  atSign && -1 !== dot && dot > atSign && 
      dot !== (value.length - 1))
    {
      if (!window.emailRegEx.test(value))
      {
        valid = false;
        emailAddressFB = "That does not look like a valid email address";
      }
      else
      {
        valid = true;
        this.debouncedCheckEmailAddress(value)
      }
    }      

    this.setState(
    {
      newEmailAddress: value, 
      emailAddressFB: emailAddressFB, 
      emailAddressValid: valid,
      modalButtonDisabled: true
    });
  }

  setValidationCode(event)
  {
    let modalButtonDisabled = 8 === event.target.value.trim().length ? false : true;
    this.setState({validationCode: event.target.value.trim(), modalButtonDisabled});
  }

  toggleModal()
  {
    this.setState({modalIsOpen: false});
  }

  async updateUserInfo(event)
  {
    event.preventDefault();

    if (!this.state.firstNameValid || !this.state.lastNameValid)
    {
      this.context.postNotification('info', 'Please correct the errors on the page.');
      return;
    }

    this.setState({updateButtonDisabled: true});

    let bodyData = {};
    bodyData.firstName = this.state.firstName;
    bodyData.middleName = this.state.middleName;
    bodyData.lastName = this.state.lastName;

    let result = await this.context.dbTwig.callRestAPI('icam', 'updateUserInfo', bodyData);
    if ('success' !== result.status)
    {
      this.setState({updateButtonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error updating user info');
    } 

    this.context.postNotification('info', 'Your profile has been updated.');
    this.setState({updateButtonDisabled: false});
    this.context.userSession.getSessionInfo(this.context.dbTwig);
  }

  async validateChangeEmailCode()
  {
    var bodyData = {};
    bodyData.confirmationCode = this.state.validationCode;
    let result = await this.context.dbTwig.callRestAPI('icam', 'validateChangeEmailCode', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error validating new email confirmation code.');
    this.context.postNotification('success', 'Your new email address has been validated.');
    this.context.userSession.getSessionInfo(this.context.dbTwig);
    this.setState({modalIsOpen: false, emailAddress: this.state.newEmailAddress, newEmailAddress: undefined});
  }
}

UserInfo.contextType = AppContext;

export default UserInfo